// extracted by mini-css-extract-plugin
export default {"loaderContainer":"rich-text-editor_loaderContainer__ZzpT9"};